import { useCallback, useEffect, useState } from 'react';
import api from './api';

export const useCourseProgress = (courseId, user) => {
  const [completed, setCompleted] = useState(new Set());
  const [lastId, setLastId] = useState('');
  const [loaded, setLoaded] = useState(false);
  const uid = user?.user_id;
  useEffect(() => {
    let alive = true;
    setLoaded(false); setCompleted(new Set()); setLastId('');
    if (!uid || !courseId) { setLoaded(true); return undefined; }
    api.get(`/progress/${courseId}`).then(({ data }) => { if (alive) { setCompleted(new Set(data.completed || [])); setLastId(data.last_lesson_id || ''); } }).catch(() => {}).finally(() => { if (alive) setLoaded(true); });
    return () => { alive = false; };
  }, [courseId, uid]);

  const apply = (data) => { setCompleted(new Set(data.completed || [])); setLastId(data.last_lesson_id || ''); };
  const setDone = useCallback(async (lessonId, done = true) => {
    if (!user) return;
    const { data } = await api.post(`/progress/${courseId}/complete`, { lesson_id: lessonId, completed: done });
    apply(data);
  }, [courseId, user]);
  const setLast = useCallback((lessonId) => {
    if (!user) return;
    setLastId(lessonId);
    api.post(`/progress/${courseId}/last`, { lesson_id: lessonId }).catch(() => {});
  }, [courseId, user]);
  return { completed, lastId, setDone, setLast, loaded };
};
